import { Injectable, inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { PublisherService } from '../../admin/admin-publishers/publisher.service';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPermissionService {
  private authService = inject(AuthService);
  private publisherService = inject(PublisherService);

  /**
   * Checks if the current user is allowed to subscribe to score updates
   * @returns Promise<boolean> - true if user can subscribe, false otherwise
   */
  async isUserAllowToSubscribeToScore(): Promise<boolean> {
    const authUser: any = await this.authService.getAuthUser();
    
    // Check if user is admin or has subscription permission
    const allowSubscribingToScore = (authUser?.allowMatchSubscription) || authUser?.role?.value === 500 || false;
    
    // Additional check: if user is not admin, they need to have publishers to subscribe
    if (!allowSubscribingToScore) {
      return false;
    }
    
    // If user is admin, always allow
    if (authUser?.role?.value === 500) {
      return true;
    }

    // Check if user has allowed roles (publisher roles)
    const allowedRoles = [500, 211, 111];
    if (!allowedRoles.includes(authUser?.role?.value)) {
      return false;
    }
    
    // For non-admin users, check if they have publishers
    return new Promise<boolean>((resolve) => {
      this.publisherService.getPublishers().subscribe({
        next: (response: any) => {
          const publishers = response.data || [];
          const matchingPublisher = publishers.find(
            (pub: any) => pub.phone === authUser.phone || pub.email === authUser.email
          );
          const isAllow = (matchingPublisher && Array.isArray(matchingPublisher.partnerSubscription) && matchingPublisher.partnerSubscription.length > 0);
          resolve(isAllow);
        },
        error: () => {
          resolve(false);
        }
      });
    });
  }

  /**
   * Observable version of the subscription permission check
   * @returns Observable<boolean> - true if user can subscribe, false otherwise
   */
  isUserAllowToSubscribeToScore$(): Observable<boolean> {
    return from(this.isUserAllowToSubscribeToScore());
  }
}
